export default __webpack_public_path__ + "static/media/pompom_shape.3aeb729a.jpeg";